import React from 'react'

export default function Header() {
  return (

    <header id="header">
      <div className="container">

        <h1><a href="index.html">Kelechi Mbawuike</a></h1>

        <a href="index.html" className="mr-auto"><img src="assets/img/logo.png" alt="" className="img-fluid" /></a>
        <h2>I'm a passionate <span>Frontend Engineer</span> from Nigeria</h2>

        <nav id="navbar" className="navbar">
          <ul>
            <li><a className="nav-link active" href="#header">Home</a></li>
            <li><a className="nav-link" href="#about">About</a></li>
            <li><a className="nav-link" href="#resume">Resume</a></li>
            <li><a className="nav-link" href="#services">Services</a></li>
            <li><a className="nav-link" href="#portfolio">Portfolio</a></li>
            <li><a className="nav-link" href="#contact">Contact</a></li>
          </ul>
          <i className="bi bi-list mobile-nav-toggle"></i>
        </nav>

        <div className="social-links">
          <a href="https://twitter.com/igbo_dev" target="_blank" rel='noreferrer' className="twitter"><i className="bi bi-twitter"></i></a>
          <a href="https://www.hackerrank.com/kmbawuike?hr_r=1" target="_blank" rel='noreferrer' className="facebook"><i className="bi bi-code-slash"></i></a>
          <a href="https://github.com/kmbawuike" target="_blank" rel='noreferrer' className="instagram"><i className="bi bi-github"></i></a>
          <a href="https://www.linkedin.com/in/mbawuikekelechi/" target="_blank" rel='noreferrer' className="linkedin"><i className="bi bi-linkedin"></i></a>
        </div>

      </div>
    </header>
  )
}
